import { Component, OnInit, ViewEncapsulation, Optional } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { IBreadcrumb } from './breadcrumb.interface';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'suka-breadcrumb',
  template: `
    <ol class="breadcrumb" *ngIf="router">
      <li
      *ngFor="let breadcrumb of breadcrumbs$ | async; last as isLast;"
      class="breadcrumb-item"
      [ngClass]="{'active': isLast}" aria-current="page"
      >
        <a
          *ngIf="!isLast; else lastRoute"
          [routerLink]="[breadcrumb.url]"
          routerLinkActive="active"
        >
          <suka-icon icon="home" *ngIf="breadcrumb.label === 'Inicio'"></suka-icon> {{ breadcrumb.label }}
          <suka-icon icon="chevron-right"></suka-icon>
        </a>
        <ng-template #lastRoute>
          <suka-icon icon="home" *ngIf="breadcrumb.label === 'Inicio'"></suka-icon> {{ breadcrumb.label }}
        </ng-template>
      </li>
    </ol>
  `,
  encapsulation: ViewEncapsulation.None
})
export class Breadcrumb implements OnInit {
  breadcrumbs$: Observable<IBreadcrumb[]>;

  // Build your breadcrumb starting with the root route of your current activated route

  constructor(
    @Optional() private activatedRoute: ActivatedRoute,
    @Optional() public router: Router,
  ) { }

  ngOnInit() {
    if (this.router) {
      this.breadcrumbs$ = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged(),
        map(event => this.buildBreadcrumb(this.activatedRoute.root))
      );
    }
  }

  buildBreadcrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Array<IBreadcrumb> = []
  ): Array<IBreadcrumb> {
    // If no routeConfig is avalailable we are on the root path
    const label = route.routeConfig ? route.routeConfig.data['breadcrumb'] : 'Inicio';
    const path = route.routeConfig ? route.routeConfig.path : '';
    // In the routeConfig the complete path is not available,
    // so we rebuild it each time
    const nextUrl = `${url}${path}/`;
    const breadcrumb = {
      label,
      url: nextUrl,
    };
    const newBreadcrumbs = [...breadcrumbs, breadcrumb];
    if (route.firstChild) {
      // If we are not on our current path yet,
      // there will be more children to look after, to build our breadcumb
      return this.buildBreadcrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
}
